// Single source of truth for the Contentful Delivery API credentials, the
// environment mapping and the global-data entry ids.
//
// Kept as plain CommonJS (not .ts) so the build-time val-loader entry
// (utils/globalData.js) can `require` it directly — that file runs in the
// webpack loader context, before TS path aliases are resolved. TypeScript
// modules import it via esModuleInterop.

const CONTENTFUL_SPACE = 's8qothrtqrf9';
const CONTENTFUL_ACCESS_TOKEN = 'db857604e8d1eac420e74525ec9395d6ecf464bf54a2b10750ceb814aaca0a8d';

const getContentfulEnvironment = () => {
  return process.env.CONTENTFUL_ENV || (process.env.PD_ENV === 'production' ? 'master' : 'staging');
};

const GLOBAL_DATA_ENTRY_IDS = {
  nl: '7JYbgi6RCinN38rH4dg5qQ',
  de: 'wtYOE2aGXQEDbBtU64htw',
  'de-CH': '6Xmpgdxp9s2BLHernpdhNq',
};

module.exports = {
  CONTENTFUL_SPACE,
  CONTENTFUL_ACCESS_TOKEN,
  getContentfulEnvironment,
  GLOBAL_DATA_ENTRY_IDS,
};
